module.exports = __webpack_public_path__ + "smogen.jpg?bfb92b85c769f887491c019adb0af644";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/smogen.jpg
// module id = 154
// module chunks = 0